import {AnyCryptoDepositScreen} from 'src/v2/components/anyCrypto/AnyCryptoDepositScreen';
import {AnyCryptoProcessingScreen} from 'src/v2/components/anyCrypto/AnyCryptoProcessingScreen';
import {useRelayPaymentPolling} from 'src/v2/components/anyCrypto/useRelayPaymentPolling';
import {useRequestRelayQuote} from 'src/v2/components/anyCrypto/useRequestRelayQuote';
import {useSelector} from 'src/v2/state/store';

export const AnyCryptoScreen = () => {
  const step = useSelector((state) => state.anyCryptoDeposit.step);
  const {startPolling} = useRelayPaymentPolling();
  const requestRelayQuote = useRequestRelayQuote();

  if (step === 'processing') {
    return <AnyCryptoProcessingScreen />;
  }

  return (
    <AnyCryptoDepositScreen
      startPolling={startPolling}
      requestRelayQuote={requestRelayQuote}
    />
  );
};
